import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import Button from 'components/common/Button'
import ImagePreview from 'components/ImagePreview'
import { OutputFormat } from 'types/OutputFormat'
import c from './PreviewStage.module.scss'

interface PreviewStageProps {
  imageUrl: string
  outputFormat: OutputFormat
  onOutputFormatChange: (newOutputFormat: OutputFormat) => void
  onProcessingStart: () => void
}

function PreviewStage({
  imageUrl,
  outputFormat,
  onOutputFormatChange,
  onProcessingStart,
}: PreviewStageProps) {
  const { t } = useTranslation()

  const handleOutputFormatChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onOutputFormatChange(e.target.value as OutputFormat)
    },
    [onOutputFormatChange],
  )

  return (
    <>
      <ImagePreview imageUrl={imageUrl} />
      <div className="bottom">
        <div className={c.switch}>
          <label className={c.switchButton}>
            <input
              className={`sr-only ${c.switchInput}`}
              type="radio"
              name="outputFormat"
              value="jpeg"
              checked={outputFormat === 'jpeg'}
              onChange={handleOutputFormatChange}
            />
            <span className={c.switchBody}>
              <span className={c.switchHeading}>JPEG</span>
              <span className={c.switchText}>&gt; 1200х1200 px, 3 Mb</span>
              <span className={c.switchFiller} />
            </span>
          </label>
          <label className={c.switchButton}>
            <input
              className={`sr-only ${c.switchInput}`}
              type="radio"
              name="outputFormat"
              value="png"
              checked={outputFormat === 'png'}
              onChange={handleOutputFormatChange}
            />
            <span className={c.switchBody}>
              <span className={c.switchHeading}>PNG</span>
              <span className={c.switchText}>&gt; 3000х3000 px, 10 Mb</span>
              <span className={c.switchFiller} />
            </span>
          </label>
        </div>
        <Button className={c.button} onClick={onProcessingStart}>
          {t('stages.enhancement.preview.buttonText')}
        </Button>
      </div>
    </>
  )
}

export default PreviewStage
